import React from 'react';
import manuelaImage from '../../assets/images/site de vendas V2-22.png';
import illustrationLeft from '../../assets/illustrations/LandingPage/telas_site-29.png'
import illustrationRight from '../../assets/illustrations/LandingPage/site de vendas V2-23.png'

interface QuemEManuelaSectionProps {
  altBackground?: boolean;
}

const QuemEManuelaSection: React.FC<QuemEManuelaSectionProps> = ({ altBackground }) => {
  return (
    <section className="relative w-full py-16 lg:py-24 px-6 lg:px-8" style={{ backgroundColor: altBackground ? '#C29F80' : '#4f2e1d' }}>
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-24 items-start">
          {/* Coluna Esquerda - Imagem */}
          <div className="relative">
            <div className="relative w-[300px] overflow-hidden shadow-xl max-w-md mx-auto lg:max-w-none">
              <img 
                src={manuelaImage}
                alt="Manuela Xavier"
                className="w-[300px] h-full object-cover"
              />
            </div>
          </div>

          {/* Coluna Direita - Conteúdo de Texto */}
          <div className="relative z-10">
            <div className="flex flex-col lg:flex-row items-start gap-4">
              {/* "quem é" na vertical DESKTOP*/}
              <h2 className="hidden lg:block absolute transform -rotate-90 [top:350px] [left:-20px] text-5xl  font-libre italic text-laranja mb-2 lg:mb-0 transform  origin-left">
                mediação de
              </h2>

              {/* "quem é" na horizontal MOBILE*/}
              <h2 className="block lg:hidden text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-libre italic text-laranja mb-2 lg:mb-0 transform  origin-left">
                mediação de
              </h2>

              {/* "Manuela Xavier" em itálico e maior */}
              <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-libre italic text-laranja leading-tight">
                Manuela Xavier
              </h2>
            </div>

            
            <div className="lg:pl-20 pt-20 space-y-4">
              <p className={`text-base lg:text-lg font-roboto leading-relaxed ${altBackground ? 'text-[#4f2e1d]' : 'text-[#F5F5DC]'}`}>
                MANU XAVIER é psicanalista e doutora
                em Psicologia. Há anos, conduz
                experiências de leitura em que escuta,
                vida real e literatura se entrelaçam de
                forma profunda e transformadora.
              </p>
              
            </div>
          </div>
        </div>
      </div>
      <img 
        src={illustrationLeft} 
        alt="" 
        className={`hidden lg:block w-[400px] absolute left-[0px] bottom-[0px] z-[10] ${altBackground ? 'lg:hidden' : ''}`}
      />
      <img 
        src={illustrationRight} 
        alt="" 
        className={`hidden lg:block w-[300px] absolute right-[0px] z-[10] ${altBackground ? 'bottom-0' : 'bottom-[-200px]'}`}
      />
    </section>
  );
};

export default QuemEManuelaSection;